import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "modal" }
const _hoisted_2 = {
  key: 0,
  class: "modal-header"
}
const _hoisted_3 = { class: "modal-header-title" }
const _hoisted_4 = { class: "modal-body" }
const _hoisted_5 = {
  key: 1,
  class: "modal-footer"
}
const _hoisted_6 = {
  key: 0,
  class: "modal-footer-left"
}
const _hoisted_7 = {
  key: 1,
  class: "modal-footer-right"
}

import { VIconSvg } from "@/components";
import TModal from "vue-tailwind/dist/t-modal";
import {
  computed,
  ref,
  useSlots,
  watch,
} from "vue";
import { TranslateResult } from "vue-i18n";
import { isExistSlot } from "@/plugins/helpers";

interface Props {
  title?: string | TranslateResult;
  clickToClose?: boolean;
  escToClose?: boolean;
  value?: boolean;
  hideCloseButton?: boolean;
  maxWidth?: string;
  alertMessage?: string;
  useAlertBeforeClose?: boolean;
  variant?: "regular" | "inner";
}


export default /*@__PURE__*/_defineComponent({
  __name: 'VModal',
  props: {
    title: { default: "" },
    clickToClose: { type: Boolean, default: false },
    escToClose: { type: Boolean, default: true },
    value: { type: Boolean, default: false },
    hideCloseButton: { type: Boolean, default: false },
    maxWidth: { default: "md" },
    alertMessage: { default: "" },
    useAlertBeforeClose: { type: Boolean, default: false },
    variant: { default: "regular" }
  },
  emits: ["input", "close", "clickClose"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const emit = __emit;
const slots = useSlots();

const props = __props;

const localValue = ref(false);

const modalClasses = computed(() => {
  return {
    overlay: `z-50 bg-black bg-opacity-25 rounded-2xl outline-none modal-${props.variant}`,
    wrapper: `flex items-center flex-col z-50 px-3 py-12`,
    modal: `t-modal w-min bg-white shadow-outer rounded-3xl m-auto`,
    overlayEnterClass: "opacity-0",
    overlayEnterActiveClass: "transition ease-out duration-300",
    overlayEnterToClass: "opacity-100",
    overlayLeaveClass: "opacity-100",
    overlayLeaveActiveClass: "transition ease-in duration-200",
    overlayLeaveToClass: "opacity-0",
    enterClass: "opacity-0 translate-y-4 sm:translate-y-0 transform sm:scale-95",
    enterActiveClass: "transition ease-out duration-300",
    enterToClass: "opacity-100 translate-y-0 transform sm:scale-100",
    leaveClass: "opacity-100 translate-y-0 transform sm:scale-100",
    leaveActiveClass: "transition ease-in duration-200",
    leaveToClass: "opacity-0 translate-y-4 sm:translate-y-0 transform sm:scale-95",
  };
});

const wrapperClasses = computed(() => {
  return {
    "max-width-sm": props.maxWidth === "sm",
    "max-width-md": props.maxWidth === "md",
    "max-width-lg-sm": props.maxWidth === "lg-sm",
    "max-width-lg": props.maxWidth === "lg",
    "max-width-xl": props.maxWidth === "xl",
  };
});

const isShownModal = computed({
  get() {
    return localValue.value;
  },
  set(value) {
    localValue.value = value;
    emit("input", value);
  },
});

const isExistFooter = computed(() => {
  return isExistSlot("footer-left", slots) || isExistSlot("footer-right", slots);
});

const show = () => (isShownModal.value = true);

const close = () => {
  if (props.clickToClose) {
    emit("close");
    isShownModal.value = false;
  }
};

const onClickClose = () => {
  if (props.useAlertBeforeClose) {
    let orConfirmedAlert = confirm(props.alertMessage);

    if (!orConfirmedAlert) {
      return;
    }
  }

  emit("clickClose");
  emit("close");
  isShownModal.value = false;
};

watch(
  () => props.value,
  () => {
    localValue.value = props.value;
  },
  { immediate: true }
);

__expose({
  close,
  show,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(TModal), {
    ref: "pageModal",
    modelValue: isShownModal.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isShownModal).value = $event)),
    classes: modalClasses.value,
    class: _normalizeClass(["modal-container", wrapperClasses.value]),
    "click-to-close": _ctx.clickToClose,
    "esc-to-close": _ctx.escToClose,
    "hide-close-button": "",
    onClosed: close
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (!_ctx.hideCloseButton)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.title), 1),
              _createVNode(_unref(VIconSvg), {
                "data-cy": "close-modal",
                name: "Close",
                color: "fc-subduet",
                "color-tag": "stroke",
                class: "icon-close",
                onClick: onClickClose
              })
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_4, [
          _renderSlot(_ctx.$slots, "default")
        ]),
        (isExistFooter.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              (_unref(isExistSlot)('footer-left', _unref(slots)))
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _renderSlot(_ctx.$slots, "footer-left")
                  ]))
                : _createCommentVNode("", true),
              (_unref(isExistSlot)('footer-right', _unref(slots)))
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _renderSlot(_ctx.$slots, "footer-right")
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ])
    ], undefined, true),
    _: 3
  }, 8, ["modelValue", "classes", "class", "click-to-close", "esc-to-close"]))
}
}

})